<div class="auth-content">
  <parent-dynamic-form [components]="components">
  </parent-dynamic-form>
</div>